import { useState } from 'react'
import { Button, Card, theme } from 'antd'
import { VerificationCommentList } from '../VerificationCommentList'
import { VerificationCommentModal } from '../VerificationCommentModal'

type Props = {
  className?: string
  clientId: string
}

export const VerificationComments = ({ clientId, className }: Props) => {
  const { token } = theme.useToken()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Card
        title={<span style={{ fontSize: '14px' }}>Comments</span>}
        className={className}
        styles={{ header: { backgroundColor: token.colorFillAlter } }}
        extra={
          <Button
            style={{ padding: 0 }}
            type="link"
            onClick={() => setIsModalOpen(true)}
          >
            Add comment
          </Button>
        }
      >
        {clientId !== '' && (
          <VerificationCommentList entityType="client" entityId={clientId} />
        )}
      </Card>
      <VerificationCommentModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        entityType="client"
        entityId={clientId}
      />
    </>
  )
}
